import { render, staticRenderFns } from "./banner-kynorelle.vue?vue&type=template&id=c7c1283a&scoped=true&"
import script from "./banner-kynorelle.vue?vue&type=script&lang=js&"
export * from "./banner-kynorelle.vue?vue&type=script&lang=js&"
import style0 from "./banner-kynorelle.vue?vue&type=style&index=0&id=c7c1283a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c1283a",
  null
  
)

export default component.exports